module.exports = __webpack_public_path__ + "logo-without-payoff-1f37f053bdc3d024065873e1170f0e17.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-without-payoff.svg
// module id = 72
// module chunks = 0